import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { GET_MYSTAGE_LESSON_TOKEN, GET_MYSTAGE_LESSON_TOKEN_MSB } from '@/graphql/mystageLessonToken';
import logger from '@/modules/Logger';
import { bizmatesApi } from '@/utils/bizmatesApi';

export const GetLessonTokenService = {
  msb: async (lessonId) => {
    logger.debug(`[Lesson Token] Fetched lesson token from MSB GraphQL endpoint`,
      {
        operation: 'get-token'
      }
    );

    let result;
    let errMessage = '';
    let token = '';
    let socketToken = '';

    const client = myStageApolloProvider.defaultClient;
    const response = await client.query({
      query: GET_MYSTAGE_LESSON_TOKEN_MSB,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      variables: {
        student_book_id: parseInt(lessonId)
      }
    });
    
    if (response.errors) {
      let firstError = response.errors;
      if (Array.isArray(firstError) && firstError.length > 0) {
        firstError = firstError[0];
      }
      
      result = false;
      errMessage = {
        response: {
          status: firstError.extensions.status,
          data: firstError.extensions.data,
        }
      };
      logger.error(`[Lesson Token] Mystage Lesson Token request failed: ${firstError.message}`, {
        event_type: 36,
        lesson_id: lessonId
      });
    } else if (response.data?.myStageLesson?.token) {
      result = true;
      token = response.data.myStageLesson.token;
      socketToken = response.data.myStageLesson.socket_token;
    } else {
      result = false;
      errMessage = 'No token data found';
      logger.error(`[Lesson Token] Mystage Lesson Token request failed: No token data found`, {
        operation: 'get-token',
        event_type: 36,
        lesson_id: lessonId
      });
    }

    return { result, token, socketToken, errMessage };
  },

  mbti: async (lessonId) => {
    logger.debug(`[Lesson Token] Fetched lesson token from MBTI GraphQL endpoint`,
      {
        operation: 'get-token'
      }
    );

    let result;
    let errMessage = '';
    let token = '';

    const client = apolloProvider.defaultClient;
    const response = await client.query({
      query: GET_MYSTAGE_LESSON_TOKEN,
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
      variables: {
        student_book_id: parseInt(lessonId)
      }
    });

    
    if (response.errors) {
      let firstError = response.errors;
      if (Array.isArray(firstError) && firstError.length > 0) {
        firstError = firstError[0];
      }
      
      result = false;
      errMessage = {
        response: {
          status: firstError.extensions.status,
          data: firstError.extensions.data,
        }
      };
      logger.error(`[Lesson Token] Mystage Lesson Token request failed: ${firstError.message}`, {
        event_type: 36,
        lesson_id: lessonId
      });
    } else if (response.data?.mystage_lesson?.token) {
      result = true;
      token = response.data.mystage_lesson.token;
    } else {
      result = false;
      errMessage = 'No token data found';
      logger.error(`[Lesson Token] Mystage Lesson Token request failed: No token data found`, {
        operation: 'get-token',
        event_type: 36,
        lesson_id: lessonId
      });
    }

    return { result, token, errMessage };
  },

  legacy: async (lessonId) => {
    logger.debug('[Lesson Token] Fetched lesson token from legacy endpoint', { operation: 'get-token' });

    try {
      const response = await new Promise((resolve, reject) => {
        bizmatesApi.get('lesson/token',
          { params: { id: lessonId, t: Date.now() }, timeout: 10000 },
          resolve,
          reject
        );
      });

      return { result: true, token: response.data };
    } catch (err) {
      const errMessage = err.message || 'Unknown error occurred';
      logger.error(`[LessonToken] Mystage Lesson Token request failed: ${errMessage}`, {
        operation: 'get-token',
        event_type: 36,
        lesson_id: lessonId || ''
      });
      return { result: false, token: '', errMessage };
    }

  }
};
